'use strict';

angular.module('ringbaPortal')
  .filter('camelCaseFormat', ['_', function (_) {
    return function (value) {
      return _.startCase(_.snakeCase(value));
    };
  }]);
